export default {
  imageFilter: {
    tone: '色调',
    saturation: '饱和度',
    brightness: '亮度',
    ambiguity: '模糊度',
    title: '滤镜',
  },
  colorFilter: {
    title: '颜色填充',
  },
  colorPicker: {
    single: '单色',
    gradient: '渐变色',
  },
  fontLoader: {
    title: '公共字体库',
    loading: '字体加载中',
    currentFont: '当前素材字体',
    freeFont: '免费字体（可商用）',
    systemFont: '系统默认字体',
    forbidden: '字体已下架',
    all: '全部',
    applyFont: '应用到同语言的所有文本',
    applyFontSuccess: '应用成功',
    assetFont: '已上传',
    assetFontTip: '自定义上传的字体，请自行确认版权。',
  },
  fileMeta: {
    fileSize: '文件大小',
    audioDuration: '音乐时长',
    imageSize: '图片尺寸',
  },
  orientationSelector: {
    vertical: '竖屏',
    horizontal: '横屏',
  },
  ratioSelector: {
    vertical: '竖版',
    horizontal: '横版',
  },
  storagefull: {
    tips: '存储空间已满，无法进行操作。请清理资产库数据或联系销售进行空间扩容。',
  },
  batchDeal: {
    selected: '已选 {num} 项',
    selectAll: '全选',
    reverse: '反选',
    cancel: '全部取消',
  },
  translate: {
    selected: '已选中 {num} 个文本',
    selectAll: '全选',
    title: '文本翻译',
    error: '暂不支持该语言翻译。',
    error1: '如需修改语言，请先完成下方所有文本的输入。',
    selectSource: '源语言',
    select: '请选择',
    commonLanguage: '常用语言',
    allLanguage: '全部语言',
    originLanguage: '原语言',
    otherLanguage: '其他语言',
    selectTarget: '目标语言',
    translate: '翻译（内测）',
    error2: '请输入文本',
    error3: '请求超时，请',
    error3Btn: '重试。',
    track: '文本轨道',
    subtitleTrack: '字幕轨道',
    default: '默认语言',
    modify: '修改语言',
    saveAs: '另存为项目并替换',
    cancel: '取消',
    replace: '替换',
    add: '添加',
    done: '完成',
    saveAsSuccess: '成功另存为项目',
    selectSource1: '选择以下文本的语言',
    selectSource2: '选择要翻译的项目语言',
  },
  forbiddenFontDialog: {
    title: '字体丢失',
    forbiddenFont: '字体丢失',
    replaceFont: '替换字体',
  },
  videoClip: {
    clearSign: '清空标记',
    resetSign: '重置标记',
    tour: {
      step1: '点击进度条中的标记点，可跳转到对应位置。',
      step2: '拖动进度指针，点击添加标记，即可将视频切分成多个片段。',
      step3: '点击删除按钮，即可删除切分视频的标记。',
      step4: '切分后的视频片段可保存至项目素材。',
    },
  },
  speech: {
    title: '智能配音',
    labelLanguage: '字幕语音',
    labelType: '语音类型',
    checkLabel: '包含英文',
    lower: '语调较低',
    low: '语调低',
    normal: '语调正常',
    high: '语调高',
    higher: '语调较高',
  },
  assets: {
    transcode: {
      transcoding: '转码中',
      error: '转码失败',
    },
  },
  upload: {
    renamedTip: '文件名重复，已重新命名并上传',
    successfully: '文件已上传 - {checkName}',
    fileStatus: {
      success: '上传成功',
      error: '上传失败',
      uploading: '正在上传',
      invalid: '不支持文件格式',
      invalidType: '不允许上传其他类型文件',
      warningDragonboneSize: '龙骨大小不可超过{size}MB',
      warningXlzSize: '序列帧大小不能超过{size}MB',
      warningMaxSize: '文件大小不能超过 {size} MB',
      resolveError: '文件处理失败',
      verticesRules: '顶点、法线、纹理坐标存在false的情况',
      meshesRules: '模型网格数量不为1',
      materialRules: '材质数量不为1',
      skinRules: '蒙皮数量不为1',
      skeletonRules: '骨骼名称与蓝本不一致',
    },
    sequenceFrameSizeDifferent: '序列帧图片尺寸不一致',
    sequenceFrameError: '请上传符合格式、大小要求的序列帧文件',
    fontWaring: '支持 {type} 格式，大小不超过{size}。',
  },
  tour: {
    skip: '跳过',
    next: '下一步',
    finish: '知道了',
  },
  resourceManager: {
    commonAudio: '公共音效库',
    commonBgm: '公共背景音乐库',
    commonAImage: '公共动图库',
    commonModel: '模型库',
    commonAction: '动作库',
  },
  apiError: '接口发生错误，请稍后再试或联系开发者',
  productDialog: {
    title: '关联产品',
    subtitle: '需先关联产品商店地址，才可进行下一步操作。',
    read: '读取',
    placeholder: '请输入商店地址',
    ok: '确认',
    cancel: '取消',
    add: '添加',
    urlError: '商店地址有误，无法读取产品信息',
  },
  projectNamePlaceholder: '项目名称',
  aiPrivacy: {
    title: 'AI生成内容免责声明',
    content:
      'Playturbo平台的AI相关服务（以下简称“本服务”）依托于生成式人工智能模型。如用户自主选择使用本服务，则视为用户已经接受并遵守与本平台及本服务相关的协议和规则（包括但不限于<a href="/#/legal-agreement">《隐私政策》、《Playturbo用户服务协议》</a>）的约束。',
    cancel: '不同意',
    agree: '同意',
  },
  aiGenerationFunction: {
    long: '丰富内容',
    short: '精简内容',
    better: '润色原句',
    translate: '重新翻译',
  },
  aitool: {
    placeholderTip: '请选择或输入指令',
  },
  action: {
    search: '查找',
    replace: '替换',
    replaceAndTranslate: '替换并翻译',
    cancel: '取消',
    findOutCount: '共找到{num}处',
  },
  tone: {
    search: {
      role: '角色',
      style: '风格',
      model: '语音',
    },
    style: {
      cheerful: '愉快',
      sad: '悲伤',
      assistant: '助理',
      chat: '聊天',
      customerservice: '客服',
      newscast: '新闻播报',
      angry: '愤怒',
      excited: '乐观',
      friendly: '友好',
      terrified: '害怕',
      shouting: '喊叫',
      unfriendly: '冷淡',
      whispering: '低语',
      hopeful: '充满希望',
      narrationprofessional: '专业叙述',
      newscastcasual: '休闲新闻',
      newscastformal: '正式新闻',
      empathetic: '关心',
      calm: '冷静',
      affectionate: '温暖亲切',
      disgruntled: '抱怨',
      fearful: '恐惧',
      gentle: '礼貌',
      lyrical: '感伤',
      serious: '严肃',
      poetryreading: '朗读诗歌',
      chatcasual: '聊天轻松',
      whisper: '耳语',
      sorry: '道歉',
      narrationrelaxed: '轻松叙述',
      embarrassed: '尴尬',
      depressed: '沮丧',
      sportscommentary: '体育播报',
      sportscommentaryexcited: '充满活力的体育播报',
      documentarynarration: '纪录片',
      envious: '钦佩',
      advertisementupbeat: '推广产品',
      livecommercial: '实时广告',
    },
    role: {
      Narrator: '旁白',
      YoungAdultMale: '青年男性',
      Boy: '男孩',
      YoungAdultFemale: '青年女性',
      OlderAdultFemale: '中年女性',
      OlderAdultMale: '中年男性',
      SeniorFemale: '老年女性',
      SeniorMale: '老年男性',
      Girl: '女孩',
    },
  },
  gender: {
    male: '男',
    female: '女',
    neutral: '不限',
  },
}
